import { init, globalHandlersIntegration, extraErrorDataIntegration, captureException, captureMessage } from "@sentry/react"
import { errorsToIgnore, groupThirdPartyStackOverflow } from "app/config/errors_to_ignore"

export function initSentryReact() {
  if (window.App?.sentryDSNGrizzlyClient) {
    init({
      dsn: window.App.sentryDSNGrizzlyClient,
      release: window.App.datadogVersion,
      initialScope: {
        user: { id: window.App?.user?.id },
      },
      // replaysSessionSampleRate: 0.0, // replay sample rate when no error occurs
      // replaysOnErrorSampleRate: 1.0, // replay sample rate when an error occurs
      integrations: [
        // Most Promise libraries have a global hook for capturing unhandled errors.
        // As we don't have control over what third-party libraries use, we'll
        // turn this kind of error off.
        globalHandlersIntegration({ onunhandledrejection: false }),

        // With this integration, Sentry will inject enumerable error properties
        // for every JS Object that errs, including non-Error ones.
        extraErrorDataIntegration(),

        // As configured above, record session replays to view in Sentry:
        // https://docs.sentry.io/product/explore/session-replay/web/
        // replayIntegration()
      ],
      ignoreErrors: errorsToIgnore,
      beforeSend: event => groupThirdPartyStackOverflow(event),
    })

    // Inject Sentry functions globally for shared utilities
    window.App = window.App || {}
    window.App.Sentry = { captureException, captureMessage }
  }
}
